import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useInfiniteQuery } from "@tanstack/react-query";

import { leadQueryKeys } from "./leadQueryKeys";

export function useInfiniteQueryLeadList(
  {
    api,
    opts = {},
    tz,
  }: {
    api: ApiType;
    opts?: Parameters<ApiType["leadApi"]["list"]>[0];
    tz: string;
  },
  queryOpts?: { enabled?: boolean },
) {
  return useInfiniteQuery({
    queryKey: leadQueryKeys.list(opts),
    queryFn: async ({ pageParam }: { pageParam?: string }) => {
      const parsedOpts = { ...opts, nextPageToken: pageParam };
      if (opts?.createdFrom) {
        parsedOpts.createdFrom = zonedTimeToUtc(opts.createdFrom, tz);
      }
      if (opts?.createdTo) {
        parsedOpts.createdTo = zonedTimeToUtc(opts.createdTo, tz);
      }

      return (await api.leadApi.list(parsedOpts)).data;
    },
    getNextPageParam: (lastPage) => lastPage.nextPageToken,
    enabled: !!tz,
    initialPageParam: undefined,
    ...queryOpts,
  });
}
